module.exports = __webpack_public_path__ + "static/media/illus green.1860f32b.png";